import { render } from "./TagVideos.vue?vue&type=template&id=1240e2aa&scoped=true"
import script from "./TagVideos.vue?vue&type=script&lang=js"
export * from "./TagVideos.vue?vue&type=script&lang=js"

import "./TagVideos.vue?vue&type=style&index=0&id=1240e2aa&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3966428095/src/eelam-tv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1240e2aa"]])

export default __exports__